import { GridPartitionWrapper } from "../../Utils/GridPartitionWrapper";
import { DashboardContainerProps } from "../Cards/Interfaces/DashboardContainer";
import { TaskSection } from "../Section/TaskSection";
import { InvoiceSection } from "../Section/InvoiceSection";
import { ProjectTrendsComponent } from "../ProjectTrends/ProjectTrends";
import { HistorySection } from "../Section/HistorySection";

export function AccountantTopDashboardContainer({ sorted_tasks, sorted_assignments, isNewCard, markAsSeen, sorted_invoices }: DashboardContainerProps) {
    return (
        <>
            <GridPartitionWrapper grid_columns={2}>
                <>
                    <TaskSection
                    sorted_tasks={sorted_tasks}
                    sorted_assignments={sorted_assignments}
                    isNewCard={isNewCard}
                    markAsSeen={markAsSeen} />

                <InvoiceSection
                    sorted_invoices={sorted_invoices ?? []}
                    isNewCard={isNewCard}
                    markAsSeen={markAsSeen} />
                </>
            </GridPartitionWrapper>
            <ProjectTrendsComponent />
            <HistorySection />
        </>
    );
}
